import { Component, OnInit, ViewChild } from '@angular/core';
import { faStar } from '@fortawesome/free-regular-svg-icons';
import { faArrowCircleDown, faArrowCircleRight, faTimes, faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css']
})
export class OrderComponent implements OnInit {

  db = firebase.firestore();
  auth = firebase.auth();
  currentUserUid;

  currentOrder = {};
  newOrders = [];
  preparingOrders = [];
  refusedOrders = [];
  finishedOrders = [];

  reasonToRefuse;

  faArrowCircleDown = faArrowCircleDown;
  faArrowCircleRight = faArrowCircleRight;
  faTimes = faTimes;
  faStar = faStar;
  faStarSolid = faStarSolid;

  cardStatus = {
    new: true,
    prepare: true,
    done: true,
    cancel: true
  }

  i;

  @ViewChild('refuseModal') refuseModal;

  constructor() {

  }
  
  ngOnInit() {
    this.i = 0;
    this.auth.onAuthStateChanged(authState => {
      this.currentUserUid = authState.uid;
      this.listenOrders(authState.uid);
    });
    
  }

  bell() {
    let audio = new Audio();
    audio.src = 'https://www.yogatech.com/apps/livehelp/bin/staff/sound/ringring.wav';
    audio.load();
    audio.muted = false;
    audio.play();
    audio.onended = function() {
      audio.remove();
    }
  }

  listenOrders(userUid) {
    this.db.collection('store').doc(userUid).collection('orders').orderBy('moment', 'desc').onSnapshot(snapshot => {
      if (snapshot.docChanges().length > 0 && snapshot.docChanges()[0].type == 'added' && this.i > 0) {
        this.bell();
      }
      this.i++;
      this.newOrders = [];
      this.preparingOrders = [];
      this.refusedOrders = [];
      this.finishedOrders = [];
      this.currentOrder = {};
      snapshot.docs.forEach(doc => {
        if (doc.data().status == 'waiting') {
          this.newOrders.push({
            id: doc.id,
            clientName: doc.data().clientName,
            clientId: doc.data().clientId,
            address: doc.data().address,
            total: doc.data().total,
            changeFor: doc.data().changeFor,
            order: doc.data().order,
            payment: doc.data().payment,
            moment: moment(doc.data().moment).format('DD/MM/YYYY HH:mm'),
            status: doc.data().status,
            observations: doc.data().observations,
            couponId: doc.data().couponId,
            couponDiscount: doc.data().couponDiscount,
            ios: doc.data().ios,
          });
        } else if (doc.data().status == 'preparing') {
          this.preparingOrders.push({
            id: doc.id,
            clientName: doc.data().clientName,
            clientId: doc.data().clientId,
            address: doc.data().address,
            total: doc.data().total,
            changeFor: doc.data().changeFor,
            order: doc.data().order,
            payment: doc.data().payment,
            moment: moment(doc.data().moment).format('DD/MM/YYYY HH:mm'),
            status: doc.data().status,
            observations: doc.data().observations,
            couponId: doc.data().couponId,
            couponDiscount: doc.data().couponDiscount,
            ios: doc.data().ios,
          });
        } else if (doc.data().status == 'refused' || doc.data().status == 'expired') {
          this.refusedOrders.push({
            id: doc.id,
            clientName: doc.data().clientName,
            clientId: doc.data().clientId,
            address: doc.data().address,
            total: doc.data().total,
            changeFor: doc.data().changeFor,
            order: doc.data().order,
            payment: doc.data().payment,
            moment: moment(doc.data().moment).format('DD/MM/YYYY HH:mm'),
            status: doc.data().status,
            reason: doc.data().reason,
            observations: doc.data().observations,
            couponId: doc.data().couponId,
            couponDiscount: doc.data().couponDiscount,
            ios: doc.data().ios,
          });
        } else if (doc.data().status == 'finished' || doc.data().status == 'received') {
          this.finishedOrders.push({
            id: doc.id,
            clientName: doc.data().clientName,
            clientId: doc.data().clientId,
            address: doc.data().address,
            total: doc.data().total,
            changeFor: doc.data().changeFor,
            order: doc.data().order,
            payment: doc.data().payment,
            moment: moment(doc.data().moment).format('DD/MM/YYYY HH:mm'),
            status: doc.data().status,
            rate: doc.data().rate,
            note: doc.data().note,
            observations: doc.data().observations,
            couponId: doc.data().couponId,
            couponDiscount: doc.data().couponDiscount,
            ios: doc.data().ios,
          });
        }
      });
    });
  }

  refuseOrder(orderId, clientId) {
    this.currentOrder = {};
    this.refuseModal.hide();
    this.db.collection('store').doc(this.currentUserUid).collection('orders').doc(orderId).update({status: 'refused', reason: this.reasonToRefuse || 'O estabelecimento não informou o motivo'});
    this.db.collection('user').doc(clientId).collection('orders').doc(orderId).update({status: 'refused', reason: this.reasonToRefuse || 'O estabelecimento não informou o motivo'});
    this.reasonToRefuse = null;
  }

  accept(orderId, clientId) {
    this.currentOrder = {};
    this.db.collection('store').doc(this.currentUserUid).collection('orders').doc(orderId).update({status: 'preparing'});
    this.db.collection('user').doc(clientId).collection('orders').doc(orderId).update({status: 'preparing'});
  }
  
  finishOrder(orderId, clientId) {
    this.currentOrder = {};
    this.db.collection('store').doc(this.currentUserUid).collection('orders').doc(orderId).update({status: 'finished'});
    this.db.collection('user').doc(clientId).collection('orders').doc(orderId).update({status: 'finished'});
  }

  toBrazilianReals(value) {
    return 'R$ ' + parseFloat(value).toFixed(2).replace('.', ',');
  }

}
